if (!customElements.get('rg-collection-views')) {
  customElements.define('rg-collection-views', class extends HTMLElement {
    connectedCallback() {
      this.collection = this.closest('.rg-minimal-collection');
      if (!this.collection) return;
      this.controller = new AbortController();
      this.media = window.matchMedia('(min-width: 990px)');
      this.preference = null;
      try {
        const stored = sessionStorage.getItem('rg-collection-layout');
        if (['single', 'double', 'compact'].includes(stored)) this.preference = stored;
      } catch {}
      this.update = () => {
        const value = this.preference || (this.media.matches ? 'compact' : 'double');
        this.collection.dataset.rgView = value;
        this.querySelectorAll('[data-rg-layout]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.rgLayout === value));
        });
      };
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-rg-layout]');
        if (!button || !this.contains(button)) return;
        this.preference = button.dataset.rgLayout;
        this.update();
        try { sessionStorage.setItem('rg-collection-layout', this.preference); } catch {}
      }, { signal: this.controller.signal });
      this.media.addEventListener('change', this.update, { signal: this.controller.signal });
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
